module.exports = __webpack_public_path__ + "img/international.7a074ed6.svg";